<template>
    <div>
        <vx-card>
            <vs-tabs :color="colorx" v-model="tabs">
                <vs-tab @click="colorx = 'primary'" label="Customer Limit Report">
                    <div class="con-tab-ejemplo">
                        <report />
                    </div>
                </vs-tab>
                <vs-tab @click="colorx = 'primary'" label="Export">
                    <div class="con-tab-ejemplo">
                        <export_customer_limit />
                    </div>
                </vs-tab>
            </vs-tabs>
        </vx-card>
    </div>
</template>
<script>
import report from "./report/index.vue";
import export_customer_limit from "./export_customer_limit/index.vue";
// import done from "./done.vue";

export default {
    components: {
        export_customer_limit,
        report
    },
    data:() => ({
        colorx: "danger",
        tabs: 0,
    })
}
</script>
